class SwatchLoader {
  constructor() {
    this.swatchCache = new Map();
    this.pendingRequests = new Map();
  }

  async getSwatches(collectionHandle) {
    // Check cache first
    if (this.swatchCache.has(collectionHandle)) {
      return this.swatchCache.get(collectionHandle);
    }

    // Check if there's a pending request
    if (this.pendingRequests.has(collectionHandle)) {
      return this.pendingRequests.get(collectionHandle);
    }

    // Create new request
    const request = fetch(`/collections/${collectionHandle}?view=swatches`)
      .then(async response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const text = await response.text();
        try {
          // Try to parse the response as JSON
          const data = JSON.parse(text);
          return data;
        } catch (e) {
          // If parsing fails, try to extract JSON from potential HTML wrapper
          const match = text.match(/{[\s\S]*}/);
          if (match) {
            return JSON.parse(match[0]);
          }
          throw new Error('Could not parse response as JSON');
        }
      })
      .then(data => {
        if (!data || !data.products) {
          throw new Error('Invalid data format received');
        }
        this.swatchCache.set(collectionHandle, data);
        this.pendingRequests.delete(collectionHandle);
        return data;
      })
      .catch(error => {
        console.error('Swatch loading error:', error);
        this.pendingRequests.delete(collectionHandle);
        throw error;
      });

    this.pendingRequests.set(collectionHandle, request);
    return request;
  }

  clearCache() {
    this.swatchCache.clear();
  }
}

window.swatchLoader = new SwatchLoader(); 